import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, setProperties, get } from '@ember/object';
import { service } from '@ember/service';

/*
  attrs
    - contactDuplicates - array
*/

export default class ContactDuplicatesComponent extends Component {
  @tracked items;

  @action
  templateDidInsert() {
    this.items = this.args.contactDuplicates.slice();
  }

  @action
  handleMerged({ contactDuplicate }) {
    this.items = this.items.filter((x) => x !== contactDuplicate);
  }

  @action
  handleNotMerged({ contactDuplicate }) {
    this.items = this.items.filter((x) => x !== contactDuplicate);
  }

  @action
  handleRecordDestroyedConfirmed(contactDuplicate) {
    this.items = this.items.filter((x) => x !== contactDuplicate);
  }
}
